var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEyeOff = function SvgEyeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5B3552",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.767 11.767a2.5 2.5 0 1 1-3.534-3.534m6.717 6.717A8.4 8.4 0 0 1 10 16.667C4.167 16.667.833 10 .833 10A15.4 15.4 0 0 1 5.05 5.05zM8.25 3.533a7.6 7.6 0 0 1 1.75-.2c5.833 0 9.167 6.667 9.167 6.667a15.4 15.4 0 0 1-1.8 2.658zM.833.833l18.334 18.334"
  })));
};
export { SvgEyeOff as ReactComponent };
export default __webpack_public_path__ + "images/eye-off.svg";